;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('BugtrackerFactory', ['$http', 'UserService', BugtrackerFactory])
  function BugtrackerFactory($http, UserService) {
    var factory = {
      getBugtrackers: getBugtrackers,
      getBugtrackersByApplications: getBugtrackersByApplications,
      getBugtrackersByAppId: getBugtrackersByAppId,
      deleteBugtracker: deleteBugtracker,

      // jira
      getJiraBugtracker: getJiraBugtracker,
      addJiraBugtracker: addJiraBugtracker,
      testJiraBugtracker: testJiraBugtracker,
      editJiraBugtracker: editJiraBugtracker,
      testExistingJiraBugtracker: testExistingJiraBugtracker,
      getJiraBugtrackerForVulnerability: getJiraBugtrackerForVulnerability,
      getJiraBugtrackerForLibrary: getJiraBugtrackerForLibrary,
      getJiraPriorityByTraces: getJiraPriorityByTraces,
      createJiraUrlWebhook: createJiraUrlWebhook,
      createJiraUrlWebhookFromExistingBugtracker:
        createJiraUrlWebhookFromExistingBugtracker,

      getJiraPriorities: getJiraPriorities,
      getJiraPrioritiesByBugtracker: getJiraPrioritiesByBugtracker,
      getJiraResolutions: getJiraResolutions,
      getJiraResolutionsByBugtracker: getJiraResolutionsByBugtracker,
      getJiraProjects: getJiraProjects,
      getJiraProjectsByBugtracker: getJiraProjectsByBugtracker,
      getJiraUsers: getJiraUsers,
      getJiraLabels: getJiraLabels,
      getJiraUsersByBugtracker: getJiraUsersByBugtracker,
      getJiraFields: getJiraFields,
      getJiraFieldsByBugtracker: getJiraFieldsByBugtracker,
      getJiraStatuses: getJiraStatuses,
      getJiraStatusesByBugtracker: getJiraStatusesByBugtracker,
      getJiraIssueTypes: getJiraIssueTypes,
      getJiraIssueTypesByBugtracker: getJiraIssueTypesByBugtracker,

      // vsts
      getVSTSBugtracker: getVSTSBugtracker,
      getVSTSBugtrackerProjects: getVSTSBugtrackerProjects,
      getExistingVSTSBugtrackerProjects: getExistingVSTSBugtrackerProjects,
      getVSTSBugtrackerProjectSettings: getVSTSBugtrackerProjectSettings,
      getExisitingVSTSBugtrackerProjectSettings:
        getExisitingVSTSBugtrackerProjectSettings,
      getVSTSBugtrackerTeamMembers: getVSTSBugtrackerTeamMembers,
      getExistingVSTSBugtrackerTeamMembers:
        getExistingVSTSBugtrackerTeamMembers,
      getVSTSBugtrackerProjectTeams: getVSTSBugtrackerProjectTeams,
      getExistingVSTSBugtrackerProjectTeams:
        getExistingVSTSBugtrackerProjectTeams,
      getVSTSBugtrackerTeamAreas: getVSTSBugtrackerTeamAreas,
      getExistingVSTSBugtrackerTeamAreas: getExistingVSTSBugtrackerTeamAreas,
      addVSTSBugtracker: addVSTSBugtracker,
      testVSTSBugtracker: testVSTSBugtracker,
      editVSTSBugtracker: editVSTSBugtracker,
      testExistingVSTSBugtracker: testExistingVSTSBugtracker,
      getVSTSBugtrackerForVulnerability: getVSTSBugtrackerForVulnerability,
      getVSTSBugtrackerForLibrary: getVSTSBugtrackerForLibrary,
      getVSTSPriorityByTraces: getVSTSPriorityByTraces,

      // github
      getGitHubBugtracker: getGitHubBugtracker,
      addGitHubBugtracker: addGitHubBugtracker,
      testGitHubBugtracker: testGitHubBugtracker,
      refreshGitHubBugtracker: refreshGitHubBugtracker,
      editGitHubBugtracker: editGitHubBugtracker,
      testExistingGitHubBugtracker: testExistingGitHubBugtracker,
      refreshExistingGitHubBugtracker: refreshExistingGitHubBugtracker,
      getGitHubBugtrackerForVulnerability: getGitHubBugtrackerForVulnerability,
      getGitHubBugtrackerForLibrary: getGitHubBugtrackerForLibrary,

      // agile central
      getAgileCentralBugtracker: getAgileCentralBugtracker,
      addAgileCentralBugtracker: addAgileCentralBugtracker,
      testAgileCentralBugtracker: testAgileCentralBugtracker,
      editAgileCentralBugtracker: editAgileCentralBugtracker,
      testExistingAgileCentralBugtracker: testExistingAgileCentralBugtracker,
      getAgileCentralBugtrackerForVulnerability:
        getAgileCentralBugtrackerForVulnerability,
      getAgileCentralBugtrackerForLibrary: getAgileCentralBugtrackerForLibrary,
      getAgileCentralPriorityByTraces: getAgileCentralPriorityByTraces,

      getAgileCentralProjects: getAgileCentralProjects,
      getAgileCentralProjectsByBugtracker: getAgileCentralProjectsByBugtracker,
      getAgileCentralEditors: getAgileCentralEditors,
      getAgileCentralEditorsByBugtracker: getAgileCentralEditorsByBugtracker,
      getAgileCentralUser: getAgileCentralUser,
      getAgileCentralUserByBugtracker: getAgileCentralUserByBugtracker,
      getAgileCentralDefectTypeDefinition: getAgileCentralDefectTypeDefinition,
      getAgileCentralDefectTypeDefinitionByBugtracker:
        getAgileCentralDefectTypeDefinitionByBugtracker,
      getAgileCentralDefectAttributes: getAgileCentralDefectAttributes,
      getAgileCentralDefectAttributesByBugtracker:
        getAgileCentralDefectAttributesByBugtracker,
      getAgileCentralAllowedValues: getAgileCentralAllowedValues,
      getAgileCentralAllowedValuesByBugtracker:
        getAgileCentralAllowedValuesByBugtracker
    }

    return factory

    // bugtrackers
    function getBugtrackers() {
      return $http.get(UserService.buildAPIUrl('/bugtrackers'))
    }

    function getBugtrackersByApplications(applications) {
      return $http.get(UserService.buildAPIUrl('/bugtrackers'), {
        params: {
          base: true,
          applications: applications
        }
      })
    }

    function getBugtrackersByAppId(appId) {
      return $http.get(UserService.buildAPIUrl('/bugtrackers/' + appId))
    }

    function deleteBugtracker(id) {
      return $http['delete'](UserService.buildAPIUrl('/bugtrackers/' + id))
    }

    // jira
    function getJiraBugtracker(id) {
      return $http.get(UserService.buildAPIUrl('/bugtrackers/jira/' + id))
    }

    function addJiraBugtracker(bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/jira'),
        bugtracker
      )
    }

    function testJiraBugtracker(bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/jira/test'),
        bugtracker
      )
    }

    function editJiraBugtracker(id, bugtracker) {
      return $http.put(
        UserService.buildAPIUrl('/bugtrackers/jira/' + id),
        bugtracker
      )
    }

    function testExistingJiraBugtracker(id, bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/jira/' + id + '/test'),
        bugtracker
      )
    }

    function getJiraBugtrackerForVulnerability(id, appId) {
      return $http.get(
        UserService.buildAPIUrl(
          '/bugtrackers/jira/' + id + '/vulnerability/' + appId
        )
      )
    }

    function getJiraBugtrackerForLibrary(id) {
      return $http.get(
        UserService.buildAPIUrl('/bugtrackers/jira/' + id + '/library')
      )
    }

    function getJiraPriorityByTraces(id, traces, appId) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/jira/' + id + '/priority/' + appId
        ),
        { traces: traces }
      )
    }

    function createJiraUrlWebhook() {
      return $http.get(UserService.buildAPIUrl('/bugtrackers/jira/webhook/url'))
    }

    function createJiraUrlWebhookFromExistingBugtracker(id) {
      return $http.get(
        UserService.buildAPIUrl('/bugtrackers/jira/webhook/url/' + id)
      )
    }

    //jira v2
    function getJiraPriorities(request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/jira/priorities'),
        request
      )
    }

    function getJiraPrioritiesByBugtracker(id, request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/jira/' + id + '/priorities'),
        request
      )
    }

    function getJiraResolutions(request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/jira/resolutions'),
        request
      )
    }

    function getJiraResolutionsByBugtracker(id, request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/jira/' + id + '/resolutions'),
        request
      )
    }

    function getJiraProjects(request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/jira/projects'),
        request
      )
    }

    function getJiraProjectsByBugtracker(id, request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/jira/' + id + '/projects'),
        request
      )
    }

    function getJiraUsers(request, projectKey) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/jira/projects/' + projectKey + '/users'
        ),
        request
      )
    }

    function getJiraLabels(request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/jira/labels'),
        request
      )
    }

    function getJiraUsersByBugtracker(id, request, projectKey) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/jira/' + id + '/projects/' + projectKey + '/users'
        ),
        request
      )
    }

    function getJiraFields(request, projectKey, issueTypeID) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/jira/projects/' +
            projectKey +
            '/issueTypes/' +
            issueTypeID +
            '/fields'
        ),
        request
      )
    }

    function getJiraFieldsByBugtracker(id, request, projectKey, issueTypeID) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/jira/' +
            id +
            '/projects/' +
            projectKey +
            '/issueTypes/' +
            issueTypeID +
            '/fields'
        ),
        request
      )
    }

    function getJiraIssueTypes(request, projectKey) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/jira/projects/' + projectKey + '/issueTypes'
        ),
        request
      )
    }

    function getJiraIssueTypesByBugtracker(id, request, projectKey) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/jira/' + id + '/projects/' + projectKey + '/issueTypes'
        ),
        request
      )
    }

    function getJiraStatuses(request, projectKey) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/jira/projects/' + projectKey + '/statuses'
        ),
        request
      )
    }

    function getJiraStatusesByBugtracker(id, request, projectKey) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/jira/' + id + '/projects/' + projectKey + '/statuses'
        ),
        request
      )
    }

    // vsts

    function getVSTSBugtracker(id) {
      return $http.get(UserService.buildAPIUrl('/bugtrackers/vsts/' + id))
    }

    function getVSTSBugtrackerProjects(data) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/vsts/projects'),
        data
      )
    }

    function getExistingVSTSBugtrackerProjects(id, data) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/vsts/' + id + '/projects'),
        data
      )
    }

    function getVSTSBugtrackerProjectSettings(data) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/vsts/project/settings'),
        data
      )
    }

    function getExisitingVSTSBugtrackerProjectSettings(id, data) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/vsts/' + id + '/project/settings'
        ),
        data
      )
    }

    function getVSTSBugtrackerTeamMembers(data) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/vsts/project/team/members'),
        data
      )
    }

    function getExistingVSTSBugtrackerTeamMembers(id, data) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/vsts/' + id + '/project/team/members'
        ),
        data
      )
    }

    function getVSTSBugtrackerProjectTeams(data) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/vsts/project/teams'),
        data
      )
    }

    function getExistingVSTSBugtrackerProjectTeams(id, data) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/vsts/' + id + '/project/teams'),
        data
      )
    }

    function getVSTSBugtrackerTeamAreas(data) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/vsts/project/team/areas'),
        data
      )
    }

    function getExistingVSTSBugtrackerTeamAreas(id, data) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/vsts/' + id + '/project/team/areas'
        ),
        data
      )
    }

    function addVSTSBugtracker(bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/vsts'),
        bugtracker
      )
    }

    function testVSTSBugtracker(bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/vsts/test'),
        bugtracker
      )
    }

    function editVSTSBugtracker(id, bugtracker) {
      return $http.put(
        UserService.buildAPIUrl('/bugtrackers/vsts/' + id),
        bugtracker
      )
    }

    function testExistingVSTSBugtracker(id, bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/vsts/' + id + '/test'),
        bugtracker
      )
    }

    function getVSTSBugtrackerForVulnerability(id, appId) {
      return $http.get(
        UserService.buildAPIUrl(
          '/bugtrackers/vsts/' + id + '/vulnerability/' + appId
        )
      )
    }

    function getVSTSBugtrackerForLibrary(id) {
      return $http.get(
        UserService.buildAPIUrl('/bugtrackers/vsts/' + id + '/library')
      )
    }

    function getVSTSPriorityByTraces(id, traces, appId) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/vsts/' + id + '/priority/' + appId
        ),
        { traces: traces }
      )
    }

    //github

    function getGitHubBugtracker(id) {
      return $http.get(UserService.buildAPIUrl('/bugtrackers/github/' + id))
    }

    function addGitHubBugtracker(bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/github'),
        bugtracker
      )
    }

    function testGitHubBugtracker(bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/github/test'),
        bugtracker
      )
    }

    function refreshGitHubBugtracker(bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/github/refresh'),
        bugtracker
      )
    }

    function editGitHubBugtracker(id, bugtracker) {
      return $http.put(
        UserService.buildAPIUrl('/bugtrackers/github/' + id),
        bugtracker
      )
    }

    function testExistingGitHubBugtracker(id, bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/github/' + id + '/test'),
        bugtracker
      )
    }

    function refreshExistingGitHubBugtracker(id, bugtracker) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/github/' + id + '/refresh'),
        bugtracker
      )
    }

    function getGitHubBugtrackerForVulnerability(id, appId) {
      return $http.get(
        UserService.buildAPIUrl(
          '/bugtrackers/github/' + id + '/vulnerability/' + appId
        )
      )
    }

    function getGitHubBugtrackerForLibrary(id) {
      return $http.get(
        UserService.buildAPIUrl('/bugtrackers/github/' + id + '/library')
      )
    }

    // agile central

    function getAgileCentralBugtracker(id) {
      return $http.get(
        UserService.buildAPIUrl('/bugtrackers/agilecentral/' + id)
      )
    }

    function addAgileCentralBugtracker(request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/agilecentral'),
        request
      )
    }

    function testAgileCentralBugtracker(request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/agilecentral/test'),
        request
      )
    }

    function editAgileCentralBugtracker(id, request) {
      return $http.put(
        UserService.buildAPIUrl('/bugtrackers/agilecentral/' + id),
        request
      )
    }

    function testExistingAgileCentralBugtracker(id, request) {
      return $http.put(
        UserService.buildAPIUrl('/bugtrackers/agilecentral/' + id + '/test'),
        request
      )
    }

    function getAgileCentralBugtrackerForVulnerability(id, appId) {
      return $http.get(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' + id + '/vulnerability/' + appId
        )
      )
    }

    function getAgileCentralBugtrackerForLibrary(id) {
      return $http.get(
        UserService.buildAPIUrl('/bugtrackers/agilecentral/' + id + '/library')
      )
    }

    function getAgileCentralPriorityByTraces(id, traces, appId) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' + id + '/priority/' + appId
        ),
        { traces: traces }
      )
    }

    function getAgileCentralProjects(request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/agilecentral/projects'),
        request
      )
    }

    function getAgileCentralProjectsByBugtracker(id, request) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' + id + '/projects'
        ),
        request
      )
    }

    function getAgileCentralEditors(request, projectId, keyword) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' +
            projectId +
            '/editors?keyword=' +
            keyword
        ),
        request
      )
    }

    function getAgileCentralEditorsByBugtracker(
      id,
      request,
      projectId,
      keyword
    ) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' +
            id +
            '/' +
            projectId +
            '/editors?keyword=' +
            keyword
        ),
        request
      )
    }

    function getAgileCentralUser(request, reference) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/user?ref=' + reference
        ),
        request
      )
    }

    function getAgileCentralUserByBugtracker(id, request, reference) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' + id + '/user?ref=' + reference
        ),
        request
      )
    }

    function getAgileCentralDefectTypeDefinition(request) {
      return $http.post(
        UserService.buildAPIUrl('/bugtrackers/agilecentral/defect/definition'),
        request
      )
    }

    function getAgileCentralDefectTypeDefinitionByBugtracker(id, request) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' + id + '/defect/definition'
        ),
        request
      )
    }

    function getAgileCentralDefectAttributes(request, defectId) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' + defectId + '/attributes'
        ),
        request
      )
    }

    function getAgileCentralDefectAttributesByBugtracker(
      id,
      request,
      defectId
    ) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' + id + '/' + defectId + '/attributes'
        ),
        request
      )
    }

    function getAgileCentralAllowedValues(request, attributeId) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' + attributeId + '/values'
        ),
        request
      )
    }

    function getAgileCentralAllowedValuesByBugtracker(
      id,
      request,
      attributeId
    ) {
      return $http.post(
        UserService.buildAPIUrl(
          '/bugtrackers/agilecentral/' + id + '/' + attributeId + '/values'
        ),
        request
      )
    }
  }
})()
